// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBorderOuterOutlinedSvg from "@fishx/icons-svg/es/asn/PBorderOuterOutlined";
import FishxIcon from '../components/FishxIcon';

var PBorderOuterOutlined = function PBorderOuterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBorderOuterOutlinedSvg
  }));
};

PBorderOuterOutlined.displayName = 'PBorderOuterOutlined';
export default React.forwardRef(PBorderOuterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBorderOuterOutlined.js
// module id = 3249
// module chunks = 0